import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";
import { InstallationRemoteLinkStatus } from "@/model/data/remoteLink/InstallationRemoteLinkStatus";
import { TunnelProtocolEnum } from "@/model/data/enums/TunnelProtocolEnum";

export class FetchInstallationsRemoteLinkStatusResData extends ApiGenericResponse {
    installationsList: InstallationRemoteLinkStatus[];
    totalInstallationsCount: number;
    totalActiveSession: number;
    totalInactiveSession: number;

    constructor(response: AxiosResponse) {
        super(response);
        this.installationsList = [];
        this.totalInstallationsCount = 0;
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.InstallationsList && obj.InstallationsList.length > 0) {
            obj.InstallationsList.forEach((e) => {
                let inst = new InstallationRemoteLinkStatus();
                inst.parse(e);
                this.installationsList.push(inst);
            });
        }
        if (obj.TotalInstallationsCount) this.totalInstallationsCount = obj.TotalInstallationsCount;
        if (obj.TotalInstallationActiveSessions != null && obj.TotalInstallationActiveSessions != undefined) this.totalActiveSession = obj.TotalInstallationActiveSessions;
        if (obj.TotalInstallationInactiveSessions != null && obj.TotalInstallationInactiveSessions != undefined) this.totalInactiveSession = obj.TotalInstallationInactiveSessions;
    }
}
